import { named, withDependencies } from '@wix/thunderbolt-ioc'
import {
	BIReporter,
	BISymbol,
	CommonConfig,
	SiteFeatureConfigSymbol,
	BrowserWindowSymbol,
	BrowserWindow,
} from '@wix/thunderbolt-symbols'
import { ICommonConfig, ICommonConfigState } from './types'
import { name } from './symbols'
import { isSSR } from '@wix/thunderbolt-commons'

const commonConfigFactory = (
	initialCommonConfig: CommonConfig,
	biReporter: BIReporter,
	window: BrowserWindow
): ICommonConfig => {
	const state: ICommonConfigState = {
		commonConfig: initialCommonConfig,
		subscribers: [],
	}

	return {
		getCommonConfig: () => state.commonConfig,
		getCommonConfigForUrl: () => {
			const commonConfigQueryParam: any = { ...state.commonConfig }
			// Needed since the Aspect in the server expects BSI according to it's proto: https://github.com/wix-private/fed-infra/blob/master/fed-infra-protos/src/main/proto/common-config.proto#L26
			commonConfigQueryParam.BSI = commonConfigQueryParam.bsi
			// using deny list instead so we don't need to manually add every new property
			delete commonConfigQueryParam.consentPolicyHeader
			delete commonConfigQueryParam.consentPolicy
			return commonConfigQueryParam
		},
		updateCommonConfig: (config: Partial<CommonConfig>) => {
			if (config.hasOwnProperty('bsi')) {
				biReporter.setDynamicSessionData({ bsi: config.bsi })
			}
			state.commonConfig = { ...state.commonConfig, ...config }
			state.subscribers.forEach((subscriber) => subscriber(state.commonConfig))

			if (!isSSR(window)) {
				window!.commonConfig = state.commonConfig
			}
		},
		registerToCommonConfigChange: (subscriber) => state.subscribers.push(subscriber),
	}
}

export const CommonConfigImpl = withDependencies(
	[named(SiteFeatureConfigSymbol, name), BISymbol, BrowserWindowSymbol],
	commonConfigFactory
)
